import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setBackLayout } from "../../redux/slice/system";
import { usePop, ModulePop } from "../pop";

import BackSidebar from "./sidebar";
import BackTopbar from "./topbar";
import ModulePopCheckToken from "./popCheckToken";
import ModulePopCheckPassword from "./popCheckPassword";

import LayoutCss from "../../styles/components/layout.module.scss";

export default function BackLayoutMain() {
  const redux_system = useSelector((state) => state.system);
  const dispatch = useDispatch();
  const { ...popOptions } = usePop({
    setting: [
      {
        key: "refreshToken",
        title: () => "確認",
        isOpen: false,
      },
      {
        key: "checkPassword",
        title: () => "帳戶安全性通知提醒",
        isOpen: false,
      },
    ],
  });
  // 螢幕大小設定
  const [screen, setScreen] = useState({
    width: null,
    height: null,
  });
  // 偵測螢幕大小
  useEffect(() => {
    const resize = () => {
      setScreen({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", resize);

    resize();

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  // 依照螢幕大小控制 sidebar
  useEffect(() => {
    if (!screen.width || !screen.height) {
      return;
    }

    if (screen.width <= 768) {
      dispatch(
        setBackLayout({
          isShrink: true,
        })
      );
    }
  }, [dispatch, screen]);

  return (
    <>
      <div
        className={`${LayoutCss["back-layout-wrap"]} ${
          redux_system.backLayout.isSideFixed &&
          `${LayoutCss["layout-sidebar-fixed"]}`
        } ${
          redux_system.backLayout.isSideShow &&
          `${LayoutCss["layout-sidebar-show"]}`
        }`}
      >
        {/* 左側區塊 */}
        <BackSidebar LayoutCss={LayoutCss} />

        <div className={`${LayoutCss["layout-body"]}`}>
          {/* 上方區塊 */}
          <BackTopbar LayoutCss={LayoutCss} />

          <div className={`${LayoutCss["layout-body-content"]}`}>
            <Outlet />
          </div>
        </div>
      </div>

      {ModulePop({
        ...popOptions,
        className: "w-11 lg:w-8 md:w-9 sm:w-10 max-w-30rem",
        children: (
          <>
            {popOptions.isPop.refreshToken?.isOpen && (
              <ModulePopCheckToken closePrePop={popOptions.closePop} />
            )}
            {popOptions.isPop.checkPassword?.isOpen && (
              <ModulePopCheckPassword closePrePop={popOptions.closePop} />
            )}
          </>
        ),
      })}
    </>
  );
}
